import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = {
  key: 0,
  class: "p-col"
}
const _hoisted_4 = { class: "table-header" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_DomainsManagementDialog = _resolveComponent("DomainsManagementDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.domainsManagement.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_KnFabButton, {
          icon: "fas fa-plus",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm())),
          "data-test": "open-form-button"
        })
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_DataTable, {
              value: _ctx.domains,
              paginator: true,
              loading: _ctx.loading,
              rows: 20,
              selection: _ctx.selectedDomain,
              "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedDomain = $event)),
              selectionMode: "single",
              class: "p-datatable-sm kn-table",
              dataKey: "id",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
              filterDisplay: "menu",
              globalFilterFields: _ctx.domainsManagementDescriptor.globalFilterFields,
              rowsPerPageOptions: [10, 15, 20],
              responsiveLayout: "stack",
              breakpoint: "960px",
              currentPageReportTemplate: 
                        _ctx.$t('common.table.footer.paginated', {
                            first: '{first}',
                            last: '{last}',
                            totalRecords: '{totalRecords}'
                        })
                    ,
              onRowClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showForm($event))),
              "data-test": "domains-table"
            }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      type: "text",
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      placeholder: _ctx.$t('common.search'),
                      badge: "0",
                      "data-test": "search-input"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.domainsManagementDescriptor.columns, (col) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    field: col.field,
                    header: _ctx.$t(col.header),
                    key: col.field,
                    style: _ctx.domainsManagementDescriptor.table.column.style,
                    sortable: true,
                    class: "kn-truncated"
                  }, {
                    filter: _withCtx(({filterModel}) => [
                      _createVNode(_component_InputText, {
                        type: "text",
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                        class: "p-column-filter"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    body: _withCtx((slotProps) => [
                      _createVNode("span", {
                        title: slotProps.data[col.field]
                      }, _toDisplayString(slotProps.data[col.field]), 9, ["title"])
                    ]),
                    _: 2
                  }, 1032, ["field", "header", "style"]))
                }), 128)),
                _createVNode(_component_Column, {
                  style: _ctx.domainsManagementDescriptor.table.iconColumn.style
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Button, {
                      icon: "pi pi-trash",
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.deleteDomainConfirm(slotProps.data.valueId)),
                      "data-test": 'delete-button'
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value", "loading", "selection", "filters", "globalFilterFields", "currentPageReportTemplate"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.formVisible)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_DomainsManagementDialog, {
              model: _ctx.selectedDomain,
              onCreated: _ctx.reloadDomains,
              onClose: _ctx.closeForm,
              "data-test": "domain-form"
            }, null, 8, ["model", "onCreated", "onClose"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}